import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';


const HeroSection = () => {
  // Function to scroll to the next section
  const scrollToBottom = () => {
    window.scrollBy({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/assets/images/treatments-background.webp"
          alt="Ayurvedic Wellness Background"
          className="w-full h-full object-cover"
        />
        {/* Semi-transparent overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-background/80 via-background/70 to-background/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="space-y-8"
        >
          {/* Main Heading */}
          <div className="space-y-4">
            <motion.h1
              className="font-headline text-4xl md:text-6xl lg:text-7xl font-bold text-morph"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1, delay: 0.2 }}
            >
              Our Holistic Wellness
              <span className="block text-primary">Sanctuary</span>
            </motion.h1>

            <motion.p
              className="text-lg md:text-xl max-w-3xl mx-auto font-secondary"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Where ancient wisdom meets modern healing to transform your health from within.
              Discover the story behind Ayur Parishkar Kendra's transformative approach to restoring health and balance through authentic Ayurveda.
            </motion.p>
          </div>

          {/* Floating Stats */}
          <motion.div
            className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            {[
              { number: "30+", label: "Years Excellence", icon: "Award" },
              { number: "5000+", label: "Transformations", icon: "Sparkles" },
              { number: "50+", label: "Specialized Protocols for Autoimmune & Chronic Diseases", icon: "Dna" },
              { number: "98%", label: "Client Satisfaction", icon: "Heart" }
            ]?.map((stat, index) => (
              <motion.div
                key={index}
                className="glass-card p-6 text-center morph-hover"
                whileHover={{ scale: 1.05, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <Icon name={stat?.icon} size={32} className="text-primary mx-auto mb-3" />
                <div className="text-2xl md:text-3xl font-bold text-foreground font-headline">
                  {stat?.number}
                </div>
                <div className="text-sm text-muted-foreground font-medium">
                  {stat?.label}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 cursor-pointer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 10, 0] }}
        transition={{
          opacity: { duration: 1, delay: 1 },
          y: { duration: 2, repeat: Infinity, ease: "easeInOut" }
        }}
        onClick={scrollToBottom}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <div className="glass-panel p-3 rounded-full hover:bg-primary/10 transition-colors">
          <Icon name="ChevronDown" size={24} className="text-primary" />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;